import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Helmet } from "react-helmet-async";
import { Share2, Video, Users, Music, TrendingUp, Sparkles } from "lucide-react";

const subServices = ["TikTok Content", "Short Form Video Creation", "UGC"];

const features = [
  {
    icon: Video,
    title: "TikTok Content",
    description: "Engaging TikTok videos optimized for the algorithm and designed to go viral.",
  },
  {
    icon: Sparkles,
    title: "Short Form Videos",
    description: "Scroll-stopping content for TikTok, Instagram Reels, and YouTube Shorts.",
  },
  {
    icon: Users,
    title: "UGC Creation",
    description: "Authentic user-generated style content that feels genuine and drives engagement.",
  },
  {
    icon: Music,
    title: "Trending Sounds",
    description: "Strategic use of trending sounds and music to maximize reach and virality.",
  },
  {
    icon: TrendingUp,
    title: "Trend Integration",
    description: "We stay on top of trends and incorporate them authentically into your content.",
  },
  {
    icon: Share2,
    title: "Multi-Platform",
    description: "Content optimized for each platform's unique audience and algorithm.",
  },
];

const benefits = [
  {
    title: "Viral Potential",
    description: "Our content strategy is designed to maximize your chances of going viral.",
  },
  {
    title: "Authentic Connection",
    description: "Content that feels real, not salesy - because authenticity wins on social.",
  },
  {
    title: "Consistent Posting",
    description: "Regular content keeps you in the algorithm and builds your following.",
  },
  {
    title: "Gen Z & Millennial Reach",
    description: "Connect with younger audiences where they actually spend their time.",
  },
];

const process = [
  {
    title: "Strategy",
    description: "Understanding your brand and target social media audience.",
  },
  {
    title: "Planning",
    description: "Creating a content calendar with diverse, engaging video concepts.",
  },
  {
    title: "Production",
    description: "Creating scroll-stopping videos with trending elements and hooks.",
  },
  {
    title: "Optimize",
    description: "Analyzing performance and refining strategy for better results.",
  },
];

export default function SocialMarketing() {
  return (
    <>
      <Helmet>
        <title>Social Media Marketing | Grow Your Following & Engagement | Barton</title>
        <meta name="description" content="Expert social media marketing to grow your business on Instagram, Facebook, TikTok and more. Content creation, scheduling, and community management services." />
        <meta property="og:title" content="Social Media Marketing | Barton" />
        <meta property="og:description" content="Grow your business on Instagram, Facebook, TikTok and more. Content creation and community management." />
        <meta property="og:url" content="https://barton.uk/services/social-marketing" />
        <meta property="og:image" content="https://barton.uk/og-image.png" />
        <meta name="twitter:title" content="Social Media Marketing | Barton" />
        <meta name="twitter:description" content="Grow your business on Instagram, Facebook, TikTok and more." />
        <meta name="twitter:image" content="https://barton.uk/og-image.png" />
      </Helmet>
      <ServicePageTemplate
        title="Social Marketing"
        subtitle="Go Viral on Social"
        description="From TikTok content to UGC, we create scroll-stopping videos that build your brand and drive real engagement with your audience."
        image="https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=800&q=80"
        icon={Share2}
        features={features}
        benefits={benefits}
        process={process}
        subServices={subServices}
        ctaText="Get In Touch"
        accentColor="pink"
      />
    </>
  );
}
